﻿(function () {
  if (window.dnaskateHomeScriptReady) return;
  window.dnaskateHomeScriptReady = true;

  function splitHeading(heading) {
    if (!heading || heading.dataset.splitReady === 'true') return;

    const text = heading.textContent.trim();
    heading.textContent = '';

    let charIndex = 0;
    text.split(/(\s+)/).forEach(function (part) {
      if (!part) return;

      if (/^\s+$/.test(part)) {
        const space = document.createElement('span');
        space.className = 'dnaskate-space';
        space.textContent = ' ';
        heading.appendChild(space);
        return;
      }

      const word = document.createElement('span');
      word.className = 'dnaskate-word';

      Array.from(part).forEach(function (char) {
        const span = document.createElement('span');
        span.className = 'dnaskate-char';
        span.style.setProperty('--char-index', charIndex);
        span.textContent = char;
        word.appendChild(span);
        charIndex += 1;
      });

      heading.appendChild(word);
    });

    heading.dataset.splitReady = 'true';
  }

  function revealOnScroll() {
    const items = document.querySelectorAll('[data-reveal], .shopify-section:not(.dnaskate-dynamic-hero-section)');
    if (!('IntersectionObserver' in window)) {
      items.forEach(function (item) {
        item.classList.add('is-visible');
      });
      return;
    }

    const observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      // Large product sections can be taller than the viewport. A 12% threshold
      // can therefore never be reached, leaving the whole section transparent.
      { threshold: 0.01, rootMargin: '0px 0px -4% 0px' }
    );

    items.forEach(function (item) {
      if (!item.classList.contains('dnaskate-dynamic-hero-section')) {
        item.classList.add('dnaskate-reveal');
      }
      observer.observe(item);
    });
  }

  function bindTitleReveal() {
    const headings = Array.from(document.querySelectorAll('[data-split-heading]'));
    if (!headings.length) return;
    if (headings[0].dataset.titleRevealReady === 'true') return;
    headings.forEach(function (heading) {
      heading.dataset.titleRevealReady = 'true';
    });

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      headings.forEach(function (heading) {
        heading.style.setProperty('--dnaskate-title-pos', '112%');
        heading.style.transform = 'translate3d(0, 0, 0)';
      });
      return;
    }

    const delay = 80;
    const duration = 2050;

    function smoothstep(t) {
      return t * t * (3 - 2 * t);
    }

    function run() {
      const start = window.performance.now() + delay;

      function frame(now) {
        const raw = Math.max(0, Math.min((now - start) / duration, 1));
        const eased = smoothstep(raw);
        const pos = -7 + eased * 119;
        const lift = (1 - eased) * 7;

        headings.forEach(function (heading) {
          heading.style.setProperty('--dnaskate-title-pos', pos.toFixed(2) + '%');
          heading.style.transform = 'translate3d(0, ' + lift.toFixed(2) + 'px, 0)';
        });

        if (raw < 1) window.requestAnimationFrame(frame);
      }

      window.requestAnimationFrame(frame);
    }

    function runWhenHeroMediaReady() {
      const hero = document.querySelector('[data-dnaskate-hero]');
      const activeSlide = hero && (hero.querySelector('[data-dnaskate-hero-slide].is-active') || hero);
      const mediaItems = activeSlide
        ? Array.from(activeSlide.querySelectorAll('.dnaskate-hero__main-media, .dnaskate-hero__fill-media, video, img'))
        : [];
      const media =
        mediaItems.find(function (item) {
          return item.offsetWidth || item.offsetHeight || item.getClientRects().length;
        }) || mediaItems[0];
      let started = false;

      function startOnce() {
        if (started) return;
        started = true;
        run();
      }

      if (!media) {
        window.requestAnimationFrame(startOnce);
        return;
      }

      if (media.tagName === 'VIDEO') {
        if (media.readyState >= 2) {
          startOnce();
        } else {
          ['loadeddata', 'canplay', 'playing'].forEach(function (eventName) {
            media.addEventListener(eventName, startOnce, { once: true });
          });
        }
      } else if (media.complete && media.naturalWidth > 0) {
        startOnce();
      } else {
        media.addEventListener('load', startOnce, { once: true });
        media.addEventListener('error', startOnce, { once: true });
      }

      window.setTimeout(startOnce, 900);
    }

    runWhenHeroMediaReady();
  }

  function bindParallax() {
    const hero = document.querySelector('[data-dnaskate-hero]');
    const mediaItems = Array.from(
      document.querySelectorAll('[data-parallax-media] .dnaskate-hero__image, [data-parallax-media] .dnaskate-hero__video')
    );
    if (!hero || !mediaItems.length || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    if (hero.classList.contains('dnaskate-hero--fit-adaptive') || hero.classList.contains('dnaskate-hero--fit-cover')) return;

    let ticking = false;
    function update() {
      ticking = false;
      const maxScroll = Math.max(hero.offsetHeight - window.innerHeight, 1);
      const progress = Math.max(0, Math.min((window.scrollY - hero.offsetTop) / maxScroll, 1));
      const visual = Math.max(0, Math.min(progress * 1.04, 1));
      const amount = Math.round(visual * 48);
      hero.style.setProperty('--dnaskate-hero-progress', visual.toFixed(3));
      hero.style.setProperty('--dnaskate-card-x', Math.round(visual * 34) + 'px');
      hero.style.setProperty('--dnaskate-card-y', Math.round(visual * 22) + 'px');
      hero.style.setProperty('--dnaskate-card-bottom', Math.round(visual * 26) + 'px');
      hero.style.setProperty('--dnaskate-card-radius', Math.round(visual * 24) + 'px');
      hero.style.setProperty('--dnaskate-nav-opacity', Math.max(0, 1 - visual * 3.2).toFixed(3));
      mediaItems.forEach(function (media) {
        media.style.setProperty('--dnaskate-parallax', amount + 'px');
      });
    }

    update();
    window.addEventListener(
      'scroll',
      function () {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(update);
      },
      { passive: true }
    );
  }

  function bindHeroSlider() {
    document.querySelectorAll('[data-dnaskate-hero-slider]').forEach(function (hero) {
      const slides = Array.from(hero.querySelectorAll('[data-dnaskate-hero-slide]'));
      if (slides.length < 2 || hero.dataset.heroSliderReady === 'true') return;

      hero.dataset.heroSliderReady = 'true';
      let active = Math.max(
        0,
        slides.findIndex(function (slide) {
          return slide.classList.contains('is-active');
        })
      );
      let timer;
      const interval = Math.max(Number(hero.dataset.autoplay) || 5000, 3000);

      function updateVideos() {
        slides.forEach(function (slide, index) {
          slide.querySelectorAll('video').forEach(function (video) {
            if (index === active) {
              video.play().catch(function () {});
            } else {
              video.pause();
            }
          });
        });
      }

      function setActive(index) {
        active = (index + slides.length) % slides.length;
        slides.forEach(function (slide, slideIndex) {
          slide.classList.toggle('is-active', slideIndex === active);
          slide.setAttribute('aria-hidden', slideIndex === active ? 'false' : 'true');
        });
        updateVideos();
      }

      function start() {
        stop();
        timer = window.setInterval(function () {
          setActive(active + 1);
        }, interval);
      }

      function stop() {
        if (timer) window.clearInterval(timer);
      }

      hero.addEventListener('mouseenter', stop);
      hero.addEventListener('mouseleave', start);
      hero.addEventListener('focusin', stop);
      hero.addEventListener('focusout', start);

      setActive(active);
      if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) start();
    });
  }

  function bindShowcase() {
    document.querySelectorAll('[data-dnaskate-showcase]').forEach(function (showcase) {
      const triggers = Array.from(showcase.querySelectorAll('[data-showcase-trigger]'));
      const panels = Array.from(showcase.querySelectorAll('[data-showcase-panel]'));
      if (!triggers.length || !panels.length) return;

      let active = 0;
      let timer;

      function setActive(index) {
        active = (index + triggers.length) % triggers.length;
        triggers.forEach(function (trigger, i) {
          trigger.classList.toggle('is-active', i === active);
        });
        panels.forEach(function (panel, i) {
          panel.classList.toggle('is-active', i === active);
        });
      }

      function start() {
        stop();
        timer = window.setInterval(function () {
          setActive(active + 1);
        }, 1600);
      }

      function stop() {
        if (timer) window.clearInterval(timer);
      }

      triggers.forEach(function (trigger, index) {
        ['mouseenter', 'focus', 'click'].forEach(function (eventName) {
          trigger.addEventListener(eventName, function () {
            setActive(index);
            stop();
          });
        });
      });

      start();
    });
  }

  function bindTileParallax() {
    const tiles = Array.from(document.querySelectorAll('[data-dnaskate-tile]'));
    if (!tiles.length || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    let ticking = false;

    function update() {
      ticking = false;
      const viewport = window.innerHeight || document.documentElement.clientHeight || 1;

      tiles.forEach(function (tile) {
        const rect = tile.getBoundingClientRect();
        if (rect.bottom < -120 || rect.top > viewport + 120) return;

        const center = rect.top + rect.height / 2;
        const distance = (center - viewport / 2) / viewport;
        const offset = Math.max(-1, Math.min(1, distance)) * -26;
        tile.style.setProperty('--dnaskate-tile-parallax', offset.toFixed(2) + 'px');
      });
    }

    function requestUpdate() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(update);
    }

    update();
    window.addEventListener('scroll', requestUpdate, { passive: true });
    window.addEventListener('resize', requestUpdate);
  }

  function bindVideoReviews() {
    document.querySelectorAll('[data-dnaskate-video-reviews]').forEach(function (carousel) {
      const cards = Array.from(carousel.querySelectorAll('[data-dnaskate-video-card]'));
      if (!cards.length) return;

      const previous = carousel.querySelector('[data-dnaskate-video-prev]');
      const next = carousel.querySelector('[data-dnaskate-video-next]');
      let active = Math.min(2, Math.floor(cards.length / 2));

      function shortestOffset(index) {
        let offset = index - active;
        const half = cards.length / 2;
        if (offset > half) offset -= cards.length;
        if (offset < -half) offset += cards.length;
        return offset;
      }

      function pauseInactive() {
        cards.forEach(function (card, index) {
          const video = card.querySelector('video');
          if (!video || index === active) return;
          video.pause();
          card.classList.remove('is-playing');
        });
      }

      function setActive(index) {
        active = (index + cards.length) % cards.length;

        cards.forEach(function (card, cardIndex) {
          const offset = shortestOffset(cardIndex);
          const visible = Math.abs(offset) <= 2;

          card.dataset.offset = String(offset);
          card.classList.toggle('is-visible', visible);
          card.classList.toggle('is-active', offset === 0);
          card.setAttribute('aria-hidden', visible ? 'false' : 'true');
        });

        pauseInactive();
      }

      cards.forEach(function (card, index) {
        card.addEventListener('click', function (event) {
          if (event.target.closest('[data-dnaskate-video-play]')) return;
          if (index !== active) setActive(index);
        });

        const play = card.querySelector('[data-dnaskate-video-play]');
        const video = card.querySelector('video');

        if (play) {
          play.addEventListener('click', function () {
            if (index !== active) {
              setActive(index);
              return;
            }

            if (!video) return;
            if (video.paused) {
              video.play().catch(function () {});
              card.classList.add('is-playing');
            } else {
              video.pause();
              card.classList.remove('is-playing');
            }
          });
        }
      });

      if (previous) {
        previous.addEventListener('click', function () {
          setActive(active - 1);
        });
      }

      if (next) {
        next.addEventListener('click', function () {
          setActive(active + 1);
        });
      }

      setActive(active);
    });
  }

  function bindProductsCarousel() {
    document.querySelectorAll('[data-dnaskate-products-carousel]').forEach(function (carousel) {
      if (carousel.dataset.productsCarouselReady === 'true') return;

      const track = carousel.querySelector('[data-dnaskate-products-track]');
      const previous = carousel.querySelector('[data-dnaskate-products-prev]');
      const next = carousel.querySelector('[data-dnaskate-products-next]');
      if (!track || (!previous && !next)) return;

      carousel.dataset.productsCarouselReady = 'true';

      function getScrollStep() {
        const cards = Array.from(track.querySelectorAll('[data-dnaskate-product-card]'));
        if (cards.length > 1) return Math.abs(cards[1].offsetLeft - cards[0].offsetLeft);
        if (cards.length === 1) return cards[0].getBoundingClientRect().width;
        return track.clientWidth;
      }

      function scroll(direction) {
        const maxScroll = Math.max(track.scrollWidth - track.clientWidth, 0);
        const current = track.scrollLeft;
        const tolerance = 4;

        if (direction > 0 && current >= maxScroll - tolerance) {
          track.scrollTo({
            left: 0,
            behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
          });
          return;
        }

        if (direction < 0 && current <= tolerance) {
          track.scrollTo({
            left: maxScroll,
            behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
          });
          return;
        }

        track.scrollBy({
          left: getScrollStep() * direction,
          behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
        });
      }

      if (previous) {
        previous.addEventListener('click', function () {
          scroll(-1);
        });
      }

      if (next) {
        next.addEventListener('click', function () {
          scroll(1);
        });
      }
    });
  }

  function bindBenefitsProductsCarousel() {
    document.querySelectorAll('[data-dnaskate-benefits-products]').forEach(function (section) {
      if (section.dataset.benefitsProductsReady === 'true') return;

      const track = section.querySelector('[data-dnaskate-benefits-track]');
      const previous = section.querySelector('[data-dnaskate-benefits-prev]');
      const next = section.querySelector('[data-dnaskate-benefits-next]');
      if (!track || (!previous && !next)) return;

      section.dataset.benefitsProductsReady = 'true';

      function getScrollStep() {
        const cards = Array.from(track.querySelectorAll('.dnaskate-benefits-products__product'));
        if (cards.length > 1) return Math.abs(cards[1].offsetLeft - cards[0].offsetLeft);
        if (cards.length === 1) return cards[0].getBoundingClientRect().width;
        return track.clientWidth;
      }

      function scroll(direction) {
        track.scrollBy({
          left: getScrollStep() * direction,
          behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
        });
      }

      if (previous) {
        previous.addEventListener('click', function () {
          scroll(-1);
        });
      }

      if (next) {
        next.addEventListener('click', function () {
          scroll(1);
        });
      }
    });
  }

  function bindFloatingControls() {
    const scrollTop = document.querySelector('[data-dnaskate-scroll-top]');
    const toneToggle = document.querySelector('[data-dnaskate-tone-toggle]');

    if (scrollTop) {
      scrollTop.addEventListener('click', function () {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      });
    }

    if (toneToggle) {
      toneToggle.addEventListener('click', function () {
        document.documentElement.classList.toggle('dnaskate-tone-soft');
      });
    }
  }

  function updateCartCount() {
    return window
      .fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (response) {
        if (!response.ok) return null;
        return response.json();
      })
      .then(function (cart) {
        if (!cart) return;
        document.querySelectorAll('.dnaskate-hero__cart-count').forEach(function (count) {
          count.textContent = cart.item_count;
        });
      })
      .catch(function () {});
  }

  function addVariantToCart(variantId, quantity) {
    return window
      .fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: JSON.stringify({
          id: Number(variantId),
          quantity: Number(quantity) || 1,
        }),
      })
      .then(function (response) {
        if (!response.ok) throw new Error('Could not add item');
        return response.json();
      })
      .then(function (item) {
        updateCartCount();
        return item;
      });
  }

  function bindProductCards() {
    const cards = Array.from(document.querySelectorAll('[data-dnaskate-product-card]'));
    if (!cards.length) return;

    cards.forEach(function (card) {
      const addButton = card.querySelector('[data-dnaskate-add]');
      if (addButton) {
        addButton.addEventListener('click', function () {
          addButton.disabled = true;
          addVariantToCart(addButton.dataset.variantId, 1)
            .then(function () {
              addButton.classList.add('is-added');
              window.setTimeout(function () {
                addButton.classList.remove('is-added');
              }, 900);
            })
            .catch(function () {})
            .finally(function () {
              addButton.disabled = false;
            });
        });
      }
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.documentElement.classList.add('dnaskate-home-template');
    document.querySelectorAll('[data-split-heading]').forEach(splitHeading);
    document.querySelectorAll('[data-dnaskate-tile-heading]').forEach(splitHeading);
    bindTitleReveal();
    revealOnScroll();
    bindHeroSlider();
    bindParallax();
    bindFloatingControls();
    bindShowcase();
    bindTileParallax();
    bindVideoReviews();
    bindProductsCarousel();
    bindBenefitsProductsCarousel();
    bindProductCards();
  });
})();
